import classNames from "classnames";

import styles from "./Subheading.module.scss";

interface IProps {
  title: string;
  className?: string;
  [x: string]: any;
}

/**
 * Subheading component
 * Show the text in Subheading.
 *
 * @param {string} title - title text
 * @param {string} className - optional class name, used for styling
 */
export default function Subheading({ title, className, ...rest }: IProps) {
  const classes = classNames(styles["subheading-root"], className);

  return (
    <h2 className={classes} {...rest}>
      {title}
    </h2>
  );
}
